import React from 'react';
import { string } from 'prop-types';
import ClassNames from 'classnames';
import { ReactComponent as LoaderLogo } from '@assets/images/loader-logo.svg';

import './GlobalLoader.scss';

const GlobalLoader = ({ className }) => (
  <div
    aria-busy="true"
    aria-label="loading app"
    className={ClassNames('global-loader', className)}
    role="progressbar"
  >
    <div className="global-loader__container">
      <div className="global-loader__logo-wrapper">
        <div className="global-loader__logo">
          <LoaderLogo />
        </div>
        <div className="global-loader__logo-background">
          <LoaderLogo />
        </div>
      </div>
    </div>
  </div>
);

GlobalLoader.propTypes = {
  className: string
};

GlobalLoader.defaultProps = {
  className: ''
};

export default GlobalLoader;
